import React, { useState, useRef, useEffect } from 'react';
import { formatShortDate, toDateInputValue, getSpecialEdition } from '../utils/pricing';

export default function DateSelect({ wednesdays, value, onChange, promo }) {
  const promoDates = promo ? promo.startDates : [];
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    function handleOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  const selectedDate = wednesdays.find(d => toDateInputValue(d) === value) || null;
  const selectedSE   = selectedDate ? getSpecialEdition(selectedDate) : null;

  function select(val) {
    onChange(val);
    setOpen(false);
  }

  return (
    <div className="date-select-wrap" ref={wrapRef}>
      {/* Trigger button */}
      <button
        type="button"
        className={`date-select-trigger${open ? ' open' : ''}`}
        onClick={() => setOpen(o => !o)}
      >
        <span className="date-select-trigger-text">
          {selectedDate ? (
            <>
              {formatShortDate(selectedDate)}
              {selectedSE && <span className="se-badge">&nbsp;SE</span>}
              {promoDates.includes(value) && <span className="promo-badge">&nbsp;SALE</span>}
            </>
          ) : (
            <span style={{ color: 'var(--charcoal-light)' }}>— Select a Wednesday —</span>
          )}
        </span>
        <span className="date-select-arrow">{open ? '▲' : '▼'}</span>
      </button>

      {/* Dropdown list */}
      {open && (
        <div className="date-select-menu">
          {/* No empty "— Select a Wednesday —" row: a bookable date is always
              pre-selected, so offering a way back to "nothing" only creates a
              validation error the advertiser has to dig themselves out of. */}
          {wednesdays.map(d => {
            const val = toDateInputValue(d);
            const se  = getSpecialEdition(d);
            const onSale = promoDates.includes(val);
            return (
              <div
                key={val}
                className={`date-select-option${val === value ? ' selected' : ''}${se ? ' se-option' : ''}${onSale ? ' promo-option' : ''}`}
                onClick={() => select(val)}
              >
                <span>{formatShortDate(d)}</span>
                {se && <span className="se-badge">SE&nbsp;&mdash;&nbsp;{se.name}</span>}
                {onSale && <span className="promo-badge">SALE</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
